import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  const handleCustomize = () => {
    alert('Η λειτουργία προσαρμογής θα είναι σύντομα διαθέσιμη');
  };

  if (!showConsent) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>Χρήση Cookies</h3>
          <p>
            Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας στον ιστότοπό μας. 
            Τα cookies μας βοηθούν να κατανοήσουμε πώς χρησιμοποιείτε τον ιστότοπό μας και να βελτιώσουμε τις υπηρεσίες μας.
          </p>
          <p>
            Τα cookies χρησιμοποιούνται για ανάλυση επισκεψιμότητας, εξατομίκευση περιεχομένου και βελτίωση της εμπειρίας χρήστη.
          </p>
          <p>
            Για περισσότερες πληροφορίες, διαβάστε την <Link to="/privacy-policy">Πολιτική Απορρήτου</Link> μας.
          </p>
        </div>
        <div className="cookie-actions">
          <button className="cookie-accept" onClick={handleAccept}>
            Αποδοχή Όλων
          </button>
          <button className="cookie-decline" onClick={handleDecline}>
            Απόρριψη
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;